import React, {FC, useState} from 'react'
import RdStationWebhookSetupModal from './RdStationWebhookSetupModal'

const RdStationIntegrationCard: FC = () => {
  const [showSetupModal, setShowSetupModal] = useState(false)

  return (
    <>
      <div className='card h-100 w-100 d-flex flex-column'>
        <div className='card-header border-0 pt-5'>
          <div className='d-flex align-items-center'>
            <div className='symbol symbol-50px me-5'>
              <div className='symbol-label bg-light-success'>
                <i className='fas fa-chart-line fs-2x text-success'></i>
              </div>
            </div>
            <div className='d-flex flex-column flex-grow-1'>
              <h3 className='card-title align-items-start flex-column mb-0'>
                <span className='card-label fw-bold fs-4 mb-2'>RD Station CRM</span>
                <span className='text-muted mt-1 fw-semibold fs-7'>
                  Crie projetos no TaskRush quando uma negociação for marcada como ganha
                </span>
              </h3>
            </div>
            <span className='badge badge-light-warning'>Beta</span>
          </div>
        </div>

        <div className='card-body pt-0 d-flex flex-column flex-grow-1'>
          <div className='mb-6 flex-grow-1'>
            <p className='text-muted fs-7 mb-4'>
              Configure o webhook no RD Station CRM. Quando uma negociação for atualizada para{' '}
              <strong>ganha (won)</strong>, um projeto será criado automaticamente no TaskRush.
            </p>

            <div className='d-flex flex-column gap-3'>
              <div className='d-flex align-items-center justify-content-between'>
                <span className='text-muted fs-7'>Tipo:</span>
                <span className='badge badge-light-info'>Webhook manual</span>
              </div>
              <div className='d-flex align-items-center justify-content-between'>
                <span className='text-muted fs-7'>Evento:</span>
                <span className='text-muted fs-7'>crm_deal_updated</span>
              </div>
            </div>
          </div>

          <div className='mt-auto'>
            <div className='d-flex flex-column gap-2'>
              <button
                type='button'
                className='btn btn-sm btn-primary w-100'
                onClick={() => setShowSetupModal(true)}
              >
                <i className='fas fa-book-open me-2'></i>
                Ver instruções e URL
              </button>
            </div>
          </div>
        </div>
      </div>

      <RdStationWebhookSetupModal show={showSetupModal} onClose={() => setShowSetupModal(false)} />
    </>
  )
}

export default RdStationIntegrationCard
